module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Robin Hathaway\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Robin Hathaway")]), _vm._v(" (1934-2013) won the SMP/Malice Domestic Competition for Best First Traditional Mystery Novel in 1997 and the 1998 Agatha Award for Best First Novel for her book "), _c('I', [_vm._v("The Doctor Digs a Grave,")]), _vm._v(" the first book in the Dr. Fenimore series. She lived in New York City and Philadelphia.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/YiXN3f/tc-custom/9781466815070.jpg?1728259177765",
      "alt": "This image is the cover for the book Doctor Digs a Grave, Dr. Fenimore Mysteries"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Doctor Digs a Grave, Dr. Fenimore Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Winner of the Agatha Award and the SMP/Malice Domestic Competition for Best First Traditional Mystery Novel")]), _c('br'), _c('br'), _c('b', [_vm._v("Available for house calls-- and homicide...")]), _c('br'), _c('br'), _vm._v("When cardiologist Dr. Andrew Fenimore isn't mending weak hearts, he's solving crimes in Philadelphia's wealthy Society Hill. But murder is the last thing the good doctor expects when he befriends a teenage boy trying to bury his dead cat. As the two dig a grave for the cat's final resting place in a vacant lot-- which happens to be an ancient burial ground-- they discover a fresh corpse, buried feet flexed, facing east, according to Lenape Indian tradition."), _c('br'), _c('br'), _vm._v("Fenimore's P.I. pastime starts to become a distinct health hazard as he and his young sidekick follow the trail of the deceased young woman straight to the son of a colleague, one of Philadelphia's most prominent surgeons. Surely the scion of a fine old Philadelphia family and his Indian fiancee ignited some powerful passions. But are they enough to risk trying for the perfect murder in a place where civility rules with an iron fist in a velvet glove?")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0